import { createSelector } from 'reselect'
import {
    projectsSourceSelector
} from 'containers/Project/Hierarchies/selectors'
import {
    revisionSelector
} from 'containers/Project/GreenlightReport/selectors'
import { projectIdSelector } from 'containers/Project/View/selectors'
import {
    usernameSelector
} from 'containers/Admin/Client/ClientDialog/selectors'



const otherLeveragedProjectsSelector = createSelector(
    projectsSourceSelector,
    (projectsSource) => projectsSource.length ?  projectsSource[0].leveragedProjectsGltReports : []
)

const selectedFastTrackProjectIndexSelector = state => state.project.greenlight.selectedFastTrackProject

const selectedFastTrackProject = createSelector(
    selectedFastTrackProjectIndexSelector,
    projectsSourceSelector,
    (index, projects) => {
        return projects.flat()[index]
    }
)

const nextRevisionIdSelector = createSelector(
    revisionSelector,
    (revisions) => {
        const next = Math.max(...revisions.map(r => parseInt(r.value))) + 1
        return Number.isFinite(next) && !isNaN(next) ? next : 1
    }
)

const sourceProjectRevisionSelector = createSelector(
    projectsSourceSelector,
    otherLeveragedProjectsSelector,
    selectedFastTrackProjectIndexSelector,
    (projects, otherLeveragedProjects, selectedIndex) => {
        const gltReports = projects.flat().concat(otherLeveragedProjects)
        return gltReports.find((report, index)=> index === selectedIndex).revision
    }
)

export {
    otherLeveragedProjectsSelector,
    selectedFastTrackProjectIndexSelector,
    selectedFastTrackProject,
    nextRevisionIdSelector,
    sourceProjectRevisionSelector
}
